import React from "react";
import { useLocation } from "react-router-dom";
import minecraftUrls from "../../../../configs/mine_craft/minecraftUrls";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo from "../../../../componets/NavBarTwo";

const ITEMS: {[index: number]: any} = {
  2: {
    id: 2,
    name: 'Addon',
    url: minecraftUrls.reportAddonsPath()
  },
  3: {
    id: 3,
    name: 'User',
    url: minecraftUrls.reportUsersPath()
  },
  4: {
    id: 4,
    name: 'Comment',
    url: minecraftUrls.reportCommentsPath()
  },
};

const _PageHeader: React.FC = () => {
  const { pathname } = useLocation();
  const activeItem = Object.values(ITEMS).find(e => e.url === pathname);

  return (
    <PageHeader
      title={'Reports'}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={ITEMS}
        itemIds={Object.keys(ITEMS)}
        parent={{
          name: 'All',
          url: minecraftUrls.reportsPath()
        }}
        activeId={activeItem?.id}
      />
    </PageHeader>
  );
}

export default _PageHeader;
